export default __webpack_public_path__ + "static/media/f-ass.e8bfde69.svg";